/**
 * Ask for a new summary (block 14, PRD §4.2).
 *
 * Its own hook rather than an option on `useNook`: a read-only surface —
 * the library grid, a future public share — must be able to render a summary
 * without importing the mutation that bills for one.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
import { queryKeys } from "../query-keys.js";
export function useRegenerateSummary() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => getNookClient().regenerateSummary(id),
        // No retry, unlike every other mutation in this package. A request that
        // timed out may well have been received, and this is the one call the user
        // makes that spends money — the backend dedupes it, but a retry that the
        // user did not ask for is not this hook's to make.
        retry: 0,
        // Written, not invalidated: the skeleton has to appear on the click, and
        // `useNook`'s polling starts from this flag rather than from a refetch. The
        // text itself arrives on the next poll.
        onSuccess(_result, id) {
            queryClient.setQueryData(queryKeys.nooks.detail(id), (nook) => nook && { ...nook, summaryPending: true });
        },
    });
}
//# sourceMappingURL=use-regenerate-summary.js.map